import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Card, Typography } from '@material-ui/core';

const dataChipStyles = {
  card: {
    display: 'flex',
    padding: 16,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  number: {
    fontWeight: 'bold',
  },
  detail: {
    marginLeft: 20,
  },
};

const dataChipPropTypes = {
  description: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const DataChipStyled = ({ description, value, classes }) => (
  <Card className={classes.card}>
    <div className={classes.container}>
      <Typography variant="headline" className={classes.number}>
        {value}
      </Typography>
    </div>
    <div className={classes.container}>
      <Typography variant="headline" className={classes.detail}>
        {description}
      </Typography>
    </div>
  </Card>
);
DataChipStyled.propTypes = dataChipPropTypes;
const DataChip = withStyles(dataChipStyles)(DataChipStyled);

const propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const DataChips = ({ data }) => (
  <Grid container>
    <Grid item xs={12}>
      <Grid
        container
        spacing={16}
        alignItems="center"
        direction="row"
        justify="flex-start"
      >
        {data.map(item => (
          <Grid key={item.description} item>
            <DataChip value={item.value} description={item.description} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  </Grid>
);

DataChips.propTypes = propTypes;
export default DataChips;



// WEBPACK FOOTER //
// ./src/components/DataChips/DataChips.js